import { APPLICATION_KEY } from '../../constants';

export const SECURITY_KEY = 'security';
export const SURVEILLANCE_KEY = 'surveillance';
export const SUGGESTER_KEY = 'suggester';

export const APPLICATION_SECURITY_KEY = `${APPLICATION_KEY}:${SECURITY_KEY}`;
export const APPLICATION_SURVEILLANCE_KEY = `${APPLICATION_KEY}:${SURVEILLANCE_KEY}`;
export const APPLICATION_SUGGESTER_KEY = `${APPLICATION_KEY}:${SUGGESTER_KEY}`;
